export default function getOrgProductsByOrgId(state, id) {
  const { orgProducts } = state;

  if (orgProducts.hasOwnProperty(id)) {
    return orgProducts[id];
  }

  return id ? null : [];
}
